import React from 'react'
import OnOffToggle from './on_off_toggle'
import Dropdown from 'react-bootstrap/lib/Dropdown'
import DropdownToggle from 'react-bootstrap/lib/DropdownToggle'
import MenuItem from 'react-bootstrap/lib/MenuItem'
import {getDefaultTimespan} from '../util/date_utils'

export default class TagGoal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            interval: this.props.interval || "week",
            isNew: this.props.isNew,
            hours: this.props.hours,
        }
    }

    updateUpstream = () => {
        const { onUpdate } = this.props
        onUpdate(this.state)
    }

    doSelectUnit = (interval) => {
        const span = getDefaultTimespan(interval)
        this.setState({interval, startDate: new Date(span.start)}, this.updateUpstream)
    }

    updateHours = (hours) => {
        this.setState({
            hours: parseInt(hours.target.value),
        }, this.updateUpstream)
    }

    render() {
        const { on, onClick, hours } = this.props
        const { interval } = this.state

        return (
            <div className="tag-goal">

                <div className="goal-header">
                    <div className="goal-label">Goal</div>
                    <div className="goal-control">
                        <OnOffToggle on={on} onClick={onClick} />
                    </div>
                </div>
                {on && <div className="goal-body">
                    <input type="text"
                        className="form-control hours"
                        autoFocus={true}
                        value={hours}
                        onChange={this.updateHours}/>
                    <div className="units-label">Hours per</div>

                    <Dropdown
                        id="goal-unit"
                        className="btn-group"
                        onSelect={this.doSelectUnit} >
                        <DropdownToggle
                            className="btn-units"
                            noCaret>
                            {interval}
                            <i className="fa fa-chevron-down" aria-hidden="true"/>
                        </DropdownToggle>
                        <Dropdown.Menu>
                            <MenuItem key={"day"} eventKey={"day"}>Day</MenuItem>
                            <MenuItem key={"week"} eventKey={"week"}>Week (Monday - Sunday)</MenuItem>
                            <MenuItem key={"month"} eventKey={"month"}>Calendar Month</MenuItem>
                            <MenuItem key={"year"} eventKey={"year"}>Year</MenuItem>
                        </Dropdown.Menu>
                    </Dropdown>

                </div>}
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/tag_goal.jsx